module.exports = __webpack_public_path__ + "flag_turkey.svg?c740ed89bc7bd191bd325e5560264207";


//////////////////
// WEBPACK FOOTER
// ./assets/flags/flag_turkey.svg
// module id = 541
// module chunks = 0